<script>
  import { getWrittenName } from "../../utils/utilities";

  export let bubbleData;

  $: displayText = () => {
    if (bubbleData?.type === "file") return bubbleData.name;

    if (bubbleData?.type === "select" || bubbleData?.type === "selectAndPrice") {
      if (bubbleData?.val && bubbleData?.showWritten) {
        return getWrittenName(bubbleData.val, bubbleData.dataObject);
      }
    }

    return bubbleData?.val;
  };
</script>

<div style="text-align:right">
  <div class="chatwith-bubble-user">
    {displayText()}
  </div>
</div>
